// discover plugins
import {
  fromJS,
  List as list
} from 'immutable';

export const emptyMenu = [{
  name: 'HOME',
  id: 'homepage',
  icon: 'home',
  path: '/d/homepage',
  child: [],
  index: -100,
}];

const global = fromJS({
  fetching: list(['plugins']),
  loading: false,
  error: false,
  currentUser: false,
  loginRequired: !sessionStorage.getItem('userData'),
  data: {
    'settings/DashBoard-layouts': {
      data: [],
    },
  },

  widgets: list(JSON.parse(sessionStorage.getItem('widgets'))),
  plugins: list(JSON.parse(sessionStorage.getItem('plugins'))),
  dashboardMenu: list(),
  menu: sessionStorage.getItem('menu') ? list(JSON.parse(sessionStorage.getItem('menu'))) : emptyMenu,
  userData: {
  },
}).set(
  'userData',
  !sessionStorage.getItem('userData')
    ? {
      username: '',
      client_ip: '',
      object: null,
      autologin_object: null,
      customer_type: '',
      objects: [],
      role: '',
      object_groups: [],
      api_key: '',
      id: '',
    }
    : JSON.parse(sessionStorage.getItem('userData'))
).set(
  'apiInfo',
  !sessionStorage.getItem('apiInfo')
    ? {}
    : JSON.parse(sessionStorage.getItem('apiInfo'))
);

export default {
  global,
};



// WEBPACK FOOTER //
// ./src/utils/initialstate.js